import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/home_style.css";
import '../assets/css/global_style.css'
import "../assets/css/Responsive/home_responsive.css";
import des1 from "../assets/images/home/design1.webp";
import des2 from "../assets/images/home/design2.webp";
import des3 from "../assets/images/home/design3.webp";
import bg1 from "../assets/images/sparsh/roadside.webp";
import bg2 from "../assets/images/home/saharsh.webp";
import bg3 from "../assets/images/sparsh/roadfront.webp";
import bg4 from "../assets/images/saharsh/saharsh.webp";
import Header from "../Components/Header";

// const images = [sec1_bg_1, sec1_bg_2];

const backgroundImages = [bg1, bg2, bg3, bg4];

export default function Home() {
  const images = [bg1, bg2, bg3, bg4];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000); // change every 3 sec
    return () => clearInterval(interval);
  }, [images.length]);
  // const [currentIndex, setCurrentIndex] = useState(0);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  //   }, 5000);

  //   return () => clearInterval(intervalId);
  // }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
    }, 3000); // 5 seconds per slide

    return () => clearInterval(interval);
  }, []);

  // const scrollToSection = () => {
  //   const target = document.getElementById("sec-2");
  //   if (target) target.scrollIntoView({ behavior: "smooth" });
  // };

  document.title = "Sanvicasa - Home";
  return (
    <div>
      <div className="home-container">

        <div className="home">
          <Header />

          {/* <section
            className="hero"
            style={{ backgroundImage: `url(${bg1})` }}
          > */}

          <section
            className="hero"
            style={{
              backgroundImage: `url(${images[currentIndex]})`,
            }}
          >
            <div className="hero-content">
              <h1>FIND YOUR PERFECT HOME TODAY </h1>
              <p>
                We provide tailored real estate solutions, guiding you through
                every step with personalized experiences that meet your unique
                needs and aspirations.
              </p>
              <Link to="/saharsh">
                <button className="explore-btn">Explore Properties →</button>
              </Link>
            </div>
          </section>
        </div>


        <section className="sec2" id="sec-2" data-aos="fade-up">
          <div className="design1" data-aos="fade-up" data-aos-delay="200">
            <img src={des1} alt="Des1" />
          </div>
          <div className="details">
            <h2 data-aos="fade-up">Space for Eliteness</h2>
            <p data-aos="fade-up">
              At SanviCasa, we don’t just build homes — we craft legacies. Our
              curated collection of high-end residences is designed to offer an
              extraordinary lifestyle defined by elegance, exclusivity, and
              enduring value. Every property reflects our unwavering commitment
              to architectural brilliance and refined living.
            </p>
            <div className="detail-points">
              <h3>Why SanviCasa?</h3>
              <ul>
                <li data-aos="fade-up" data-aos-delay="300">
                  Architectural Brilliance Impeccably designed homes that blend
                  modern aesthetics with timeless appeal.
                </li>
                <li data-aos="fade-up" data-aos-delay="300">
                  Premium Comfort & Finish Interiors that boast the finest
                  materials, intelligent layouts, and luxurious detailing.
                </li>
                <li data-aos="fade-up" data-aos-delay="300">
                  Exclusive Lifestyle Amenities Enjoy access to private pools,
                  wellness spas, landscaped gardens, fitness centers, and
                  concierge services.
                </li>
                <li data-aos="fade-up" data-aos-delay="300">
                  Prime, Prestigious Locations From skyline views to serene
                  retreats, each SanviCasa home is located for prestige and
                  peace.
                </li>
                <li data-aos="fade-up" data-aos-delay="300">
                  Uncompromised Security Gated communities with 24/7
                  surveillance and smart access ensure complete peace of mind.
                </li>
              </ul>
            </div>
            <div className="design3" data-aos="fade-up" data-aos-delay="900">
              <img src={des3} alt="Des3" />
            </div>
          </div>
          <div className="design2" data-aos="fade-up" data-aos-delay="1000">
            <img src={des2} alt="Des2" />
          </div>
        </section>
        <section className="sec3">
          <div className="projects">
            <div className="sparsh">
              <h1>sanvicasa sparsh</h1>
              <div className="proj-detail">
                <div className="first-det">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 24 24"
                    xmlSpace="preserve"
                    className="w-6 h-6"
                  >
                    <line
                      className="st0"
                      x1="14.9"
                      y1="6.7"
                      x2="14.9"
                      y2="15.1"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      className="st0"
                      x1="14.9"
                      y1="20.2"
                      x2="14.9"
                      y2="14.2"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      className="st0"
                      x1="14.9"
                      y1="14.2"
                      x2="18"
                      y2="15.7"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18,20.1V6.7c0-0.4-0.1-0.7-0.3-1c-0.7-0.6-1.5-1.1-2.3-1.6c-0.3-0.2-0.7-0.4-1.1-0.2L6.6,7.7
              C6.2,8,5.9,8.4,5.8,8.9v7.4"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      x1="5.9"
                      y1="12.2"
                      x2="14.9"
                      y2="9.3"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4,20.2v-2.4c0-0.6,0.3-1.1,0.8-1.3l1-0.2l9.1-2.1l0,0"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18,9.3l1.7,1.7c0.3,0.3,0.4,0.6,0.4,1v8"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      x1="21"
                      y1="20.2"
                      x2="3"
                      y2="20.2"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p>3 BHK Flats & Shops</p>
                </div>
                <div className="sec-det">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 24 24"
                    xmlSpace="preserve"
                    className="w-6 h-6"
                  >
                    <line
                      x1="5.8"
                      y1="21"
                      x2="18.2"
                      y2="21"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <circle
                      cx="12"
                      cy="9.9"
                      r="2.8"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <path
                      d="M18.9,9.9C18.9,16.1,12,21,12,21S5.1,16.1,5.1,9.9C5.1,6.1,8.2,3,12,3S18.9,6.1,18.9,9.9z"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </svg>
                  <p>South Bopal Ahmedabad</p>
                </div>
                <div className="third-det">
                  <div class="progress-circle p100">
                    <span>100</span>
                    <div class="left-half-clipper">
                      <div class="first50-bar"></div>
                      <div class="value-bar"></div>
                    </div>
                  </div>

                  <p>Ready To Move In</p>
                </div>
              </div>
              <Link to="/sparsh">
                <button>know more</button>
              </Link>
            </div>
          </div>
        </section>

        <section className="sec4">
          <div className="projects">
            <div className="saharsh">
              <h1>sanvicasa saharsh</h1>
              <div className="proj-detail">
                <div className="first-det">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 24 24"
                    xmlSpace="preserve"
                    className="w-6 h-6"
                  >
                    <line
                      className="st0"
                      x1="14.9"
                      y1="6.7"
                      x2="14.9"
                      y2="15.1"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      className="st0"
                      x1="14.9"
                      y1="20.2"
                      x2="14.9"
                      y2="14.2"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      className="st0"
                      x1="14.9"
                      y1="14.2"
                      x2="18"
                      y2="15.7"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18,20.1V6.7c0-0.4-0.1-0.7-0.3-1c-0.7-0.6-1.5-1.1-2.3-1.6c-0.3-0.2-0.7-0.4-1.1-0.2L6.6,7.7
              C6.2,8,5.9,8.4,5.8,8.9v7.4"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      x1="5.9"
                      y1="12.2"
                      x2="14.9"
                      y2="9.3"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4,20.2v-2.4c0-0.6,0.3-1.1,0.8-1.3l1-0.2l9.1-2.1l0,0"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18,9.3l1.7,1.7c0.3,0.3,0.4,0.6,0.4,1v8"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      x1="21"
                      y1="20.2"
                      x2="3"
                      y2="20.2"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p>2 & 3 BHK Flats & Shops</p>
                </div>
                <div className="sec-det">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 24 24"
                    xmlSpace="preserve"
                    className="w-6 h-6"
                  >
                    <line
                      x1="5.8"
                      y1="21"
                      x2="18.2"
                      y2="21"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <circle
                      cx="12"
                      cy="9.9"
                      r="2.8"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <path
                      d="M18.9,9.9C18.9,16.1,12,21,12,21S5.1,16.1,5.1,9.9C5.1,6.1,8.2,3,12,3S18.9,6.1,18.9,9.9z"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </svg>
                  <p>South Bopal Ahmedabad</p>
                </div>
                <div className="third-det">
                  <div class="progress-circle p30">
                    <span>60</span>
                    <div class="left-half-clipper1">
                      <div class="first50-bar1"></div>
                      <div class="value-bar1"></div>
                    </div>
                  </div>

                  <p>Under Construction</p>
                </div>
              </div>
              <Link to="/saharsh">
                <button>know more</button>
              </Link>
            </div>
          </div>
        </section>
        <section className="sec5">
          <div className="contact-sec">
            <div className="detail">
              <h1>Contact</h1>
              <Link to="/contact">
                <button>know more</button>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>

  );
}
